/* Draft-only safeguards for incomplete quote replacement; never mutates the cart. */
(() => {
  'use strict';
  if (!document.documentElement.hasAttribute('data-idw-quote-guard')) return;
  const PREFIX = 'idw_quote_replace_pending_v1:';
  const PRODUCT_ID = '7289473531968';
  const validId = id => typeof id === 'string' && /^[A-Za-z0-9][A-Za-z0-9._:-]{0,127}$/.test(id);
  let sequence = 0, lastCartToken = null, notice;
  function validRecord(record, id) {
    return record && typeof record === 'object' && !Array.isArray(record) &&
      typeof record.cartToken === 'string' && record.cartToken.length > 0 &&
      validId(record.transactionId) && record.transactionId === id &&
      validId(record.fromId) && record.fromId !== id;
  }
  function records() {
    const result = [];
    for (let i = 0; i < localStorage.length; i++) {
      const key = localStorage.key(i);
      if (!key || !key.startsWith(PREFIX)) continue;
      const id = key.slice(PREFIX.length);
      let value;
      try { value = JSON.parse(localStorage.getItem(key)); } catch { throw new Error('journal-invalid'); }
      if (!validRecord(value, id)) throw new Error('journal-invalid');
      result.push(value);
    }
    return result;
  }
  function changed() {
    document.documentElement.setAttribute('data-idw-quote-guard', 'checking');
    window.dispatchEvent(new Event('idw:quote-replace-journal'));
  }
  const journal = Object.freeze({
    find(cartToken, fromId) {
      if (typeof cartToken !== 'string' || !cartToken || (fromId !== undefined && !validId(fromId))) throw new Error('journal-arguments');
      return records().filter(record => record.cartToken === cartToken && (fromId === undefined || record.fromId === fromId));
    },
    findCart(cartToken) {
      if (typeof cartToken !== 'string' || !cartToken) throw new Error('journal-arguments');
      return records().filter(record => record.cartToken === cartToken);
    },
    put(record) {
      if (!validRecord(record, record?.transactionId)) throw new Error('journal-invalid');
      const key = PREFIX + record.transactionId;
      if (localStorage.getItem(key) !== null) throw new Error('journal-exists');
      const value = JSON.stringify({cartToken:record.cartToken,transactionId:record.transactionId,fromId:record.fromId});
      localStorage.setItem(key, value);
      if (localStorage.getItem(key) !== value) throw new Error('journal-write');
      changed();
    },
    remove(id) {
      if (!validId(id)) throw new Error('journal-invalid');
      const key = PREFIX + id;
      const old = localStorage.getItem(key);
      if (old === null) throw new Error('journal-missing');
      let record;
      try { record = JSON.parse(old); } catch { throw new Error('journal-invalid'); }
      if (!validRecord(record, id)) throw new Error('journal-invalid');
      localStorage.removeItem(key);
      if (localStorage.getItem(key) !== null) throw new Error('journal-remove');
      changed();
    }
  });
  function inspect(cart) {
    if (!cart || !Array.isArray(cart.items) || typeof cart.token !== 'string' || !cart.token) throw new Error('cart-invalid');
    if (!window.IDWQuoteRestoreData || typeof window.IDWQuoteRestoreData.read !== 'function') throw new Error('validator-missing');
    const entries = records();
    if (entries.some(record => record.cartToken === cart.token)) return 'pending';
    const groups = new Map(), sources = new Map();
    for (const item of cart.items) {
      const p = item?.properties || {};
      const from = p._quote_replace_from, id = p._quote_replace_transaction;
      if (!Object.prototype.hasOwnProperty.call(p, '_quote_replace_from') && !Object.prototype.hasOwnProperty.call(p, '_quote_replace_transaction')) continue;
      if (String(item.product_id) !== PRODUCT_ID || !validId(from) || !validId(id) || from === id || p._quote_id !== id) return 'pending';
      if (groups.has(id) && groups.get(id) !== from) return 'pending';
      groups.set(id, from);
      if (sources.has(from) && sources.get(from) !== id) return 'pending';
      sources.set(from, id);
    }
    for (const [id, from] of groups) {
      if (cart.items.some(item => item?.properties?._quote_id === from)) return 'pending';
      try { window.IDWQuoteRestoreData.read(cart, id); } catch { return 'pending'; }
    }
    return 'clear';
  }
  function render(state) {
    if (!notice) {
      notice = document.createElement('section');
      notice.id = 'idw-quote-pending-notice';
      notice.setAttribute('role', 'status');
      notice.setAttribute('aria-live', 'polite');
      const title = document.createElement('p');
      const bold = document.createElement('strong'); bold.textContent = '見積内容の確認が必要です'; title.append(bold);
      const description = document.createElement('p');
      description.textContent = '変更処理の結果を確認できません。二重注文を避けるため、お支払いを一時停止しています。カートを変更せず、再確認するか当店へお問い合わせください。';
      const retry = document.createElement('button'); retry.type = 'button'; retry.className = 'button button--secondary'; retry.textContent = 'もう一度確認する'; retry.addEventListener('click', refresh);
      const contact = document.createElement('a'); contact.href = 'mailto:orders@idworld.store'; contact.textContent = 'お問い合わせ';
      notice.append(title, description, retry, contact); document.body.append(notice);
    }
    notice.hidden = state === 'clear' || state === 'checking';
  }
  async function refresh() {
    const ownSequence = ++sequence;
    document.documentElement.setAttribute('data-idw-quote-guard', 'checking');
    render('checking');
    try {
      const response = await fetch((window.Shopify?.routes?.root || '/') + 'cart.js', {credentials:'same-origin',cache:'no-store',signal:AbortSignal.timeout(20000)});
      if (!response.ok) throw new Error('cart-request');
      const cart = await response.json();
      const state = inspect(cart);
      if (ownSequence !== sequence) return;
      lastCartToken = cart.token;
      if (state === 'clear') document.documentElement.removeAttribute('data-idw-quote-guard');
      else document.documentElement.setAttribute('data-idw-quote-guard', state);
      render(state);
    } catch {
      if (ownSequence !== sequence) return;
      document.documentElement.setAttribute('data-idw-quote-guard', 'unknown');
      render('unknown');
    }
  }
  function checkoutTarget(target) {
    return target instanceof Element && target.closest('[name="checkout"],a[href*="/checkout"],.additional-checkout-buttons,.cart__dynamic-checkout-buttons,shopify-accelerated-checkout-cart,shopify-buy-it-now-button,.shopify-payment-button,[data-idw-dynamic-checkout]');
  }
  document.addEventListener('click', event => {
    const target = event.target;
    if (document.documentElement.hasAttribute('data-idw-quote-guard') && target instanceof Element && target.closest('[data-quote-remove-confirm], .idw-quote-cart-restore')) {
      event.preventDefault(); event.stopImmediatePropagation(); render('pending'); return;
    }
    if (!checkoutTarget(target)) return;
    try {
      if (!lastCartToken || records().some(record => record.cartToken === lastCartToken)) document.documentElement.setAttribute('data-idw-quote-guard', 'pending');
    } catch { document.documentElement.setAttribute('data-idw-quote-guard', 'unknown'); }
    if (document.documentElement.hasAttribute('data-idw-quote-guard')) {
      event.preventDefault(); event.stopImmediatePropagation(); render('pending');
    }
  }, true);
  document.addEventListener('submit', event => {
    if (!document.documentElement.hasAttribute('data-idw-quote-guard')) return;
    const target = event.target;
    if (target instanceof Element && (target.matches('form[action*="/cart"]') || target.matches('form[action*="/checkout"]'))) {
      event.preventDefault(); event.stopImmediatePropagation(); render('pending');
    }
  }, true);
  window.addEventListener('idw:quote-replace-journal', refresh);
  window.addEventListener('storage', event => { if (!event.key || event.key.startsWith(PREFIX)) refresh(); });
  window.addEventListener('pageshow', event => { if (event.persisted) refresh(); });
  document.addEventListener('visibilitychange', () => { if (document.visibilityState === 'visible') refresh(); });
  window.IDWQuotePendingGuard = Object.freeze({journal, refresh});
  refresh();
})();
